import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import {
  ButtonLinkIconPosition, ButtonLinkType
} from '@design-system/components/molecules/button-link/entities/button-link.types';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import {
  TypographyFontSize, TypographyColor, TypographyFontFamily
} from '@design-system/components/atoms/typography/entities/typography.types';

@Component({
  selector: 'app-section-text',
  templateUrl: './section-text.component.html',
  styleUrls: ['./section-text.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SectionTextComponent {

  @Input() text: string;
  @Input() index: number;
  @Input() isMobile: boolean;

  public seeMoreText: boolean = false;

  private classNameTextLegal: string = 'text-legal';
  private minCharacteres: number = 120;
  private maxCharacteres: number = 10000;

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;

  public readonly icons = Icon;

  public readonly iconPosition = ButtonLinkIconPosition.Right;
  public readonly buttonLinkType = ButtonLinkType.Secondary;

  constructor() { }

  get contentText(): string {
    if (this.activeSeeMore || !this.isMobile) {
      return this.text;
    }
    return this.text ? `${this.text.slice(0,
      !this.seeMoreText ? this.minCharacteres : this.maxCharacteres
    )}${!this.seeMoreText ? '...' : ''}` : '';
  }

  get activeSeeMore(): boolean {
    if (this.text.includes(this.classNameTextLegal)) {
      this.minCharacteres = 400;
    }
    return (this.isMobile && (this.text.length < this.minCharacteres));
  }

  public toggleSeeMoreText(): void {
    this.seeMoreText = !this.seeMoreText;
  }

}
